"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_CATEGORIES_BY_THEME = exports.MUTUALLY_EXCLUSIVE_CATEGORIES = exports.GOOGLE_THINGS_TO_DO_CATEGORY_LABELS = exports.GOOGLE_THINGS_TO_DO_CATEGORIES = void 0;
exports.GOOGLE_THINGS_TO_DO_CATEGORIES = [
    "adults-only",
    "animals",
    "audio-guide",
    "beaches",
    "bike-tours",
    "boat-tours",
    "city-cards",
    "classes",
    "day-trips",
    "family-friendly",
    "fast-track",
    "food",
    "guided-tours",
    "history",
    "hop-on-hop-off",
    "literature",
    "live-music",
    "museums",
    "nightlife",
    "outdoors",
    "private-tours",
    "romantic",
    "recurring-events",
    "self-guided",
    "small-group-tours",
    "sports",
    "theme-parks",
    "walking-tours",
    "wheelchair-accessible",
];
exports.GOOGLE_THINGS_TO_DO_CATEGORY_LABELS = {
    "adults-only": "Activity suitable for adults only",
    animals: "Activity centered around animals",
    "audio-guide": "Tour guided by pre-recorded commentary",
    beaches: "Activity at beaches",
    "bike-tours": "Sightseeing by bicycle",
    "boat-tours": "Sightseeing by boat",
    "city-cards": "Pass for multiple attractions",
    classes: "Class or workshop setting",
    "day-trips": "Full-day or multi-day trip",
    "family-friendly": "Suitable for all ages",
    "fast-track": "Skip-the-line admission",
    food: "Food-centered activity",
    "guided-tours": "Conducted by a guide",
    history: "History-related or historical location",
    "hop-on-hop-off": "Bus/boat hop-on hop-off tour",
    literature: "Literature theme",
    "live-music": "Live music performance",
    museums: "Museum visits",
    nightlife: "Night social activities/entertainment",
    outdoors: "Outside or nature activities",
    "private-tours": "Private group tours",
    romantic: "Recommended for couples",
    "recurring-events": "Recurring tourist events",
    "self-guided": "Self-guided with instructions",
    "small-group-tours": "Small group tours",
    sports: "Sport or fitness themed",
    "theme-parks": "Theme park visits",
    "walking-tours": "Walking tours",
    "wheelchair-accessible": "Wheelchair accessible",
};
exports.MUTUALLY_EXCLUSIVE_CATEGORIES = [
    ["adults-only", "family-friendly"],
    ["guided-tours", "self-guided"],
    ["private-tours", "small-group-tours"],
];
exports.GOOGLE_CATEGORIES_BY_THEME = {
    "Tour Types": [
        "guided-tours",
        "self-guided",
        "audio-guide",
        "private-tours",
        "small-group-tours",
        "walking-tours",
        "bike-tours",
        "boat-tours",
        "hop-on-hop-off",
    ],
    Audience: ["adults-only", "family-friendly", "wheelchair-accessible"],
    "Activity Types": ["day-trips", "classes", "sports", "food", "live-music", "nightlife", "recurring-events"],
    "Venues & Attractions": ["museums", "theme-parks", "beaches", "outdoors", "animals"],
    "Special Features": ["fast-track", "city-cards", "romantic"],
    Themes: ["history", "literature"],
};
//# sourceMappingURL=GoogleThingsToDoCategories.js.map